import { Injectable } from '@angular/core';
import { ConfigService } from '../../../service/config.service';
var FormImgService = /** @class */ (function () {
    function FormImgService(config) {
        this.config = config;
        this.host = this.config.config['assets_base'] || '';
        this.cacheInvalidateKey = '_';
    }
    FormImgService.prototype.updateCacheInvalidate = function () {
        return '?' + this.cacheInvalidateKey + '=' + Date.now();
    };
    FormImgService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FormImgService.ctorParameters = function () { return [
        { type: ConfigService }
    ]; };
    return FormImgService;
}());
export { FormImgService };
//# sourceMappingURL=img.service.js.map